import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { take } from "rxjs/operators";
import { clientConfig } from "../../constant/app.constant";
import { DeliveryOptionsService, ShippingType } from "../../services/delivery-options.service";

@Component({
  selector: "app-dropoff",
  templateUrl: "./drop-off.component.html",
  styleUrls: ["./drop-off.component.scss"],
})
export class DropOffComponent implements OnInit {
  @Input() title: any;
  param = { deliveryOptionCarrier: "" };
  merchant = { merchantTitle: "" };
  order: any;
  modeOfTransport :any;
  isDropOffStoreType: boolean;
  serviceCenterLink: any;
  isLabelPrintPageActive: boolean =  false;

  // title:clientConfig.MERCHANTNAME;
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private deliveryOptionsService: DeliveryOptionsService,
    private route: ActivatedRoute
  ) {
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        this.order = ro;
        this.isDropOffStoreType =
          this.deliveryOptionsService.getTypeByMode(ro.deliveryOption.type) === ShippingType.DropOffStore;
        this.serviceCenterLink = this.deliveryOptionsService.getShippingOption(ro.deliveryOption.type).viewServiceCenterLink;
      });
    this.merchant.merchantTitle = clientConfig.TITLE;
    this.param.deliveryOptionCarrier = this.order.deliveryOption.deliveryOptionCarrier;
    this.modeOfTransport =  this.order?.deliveryOption?.type;
  }
  ngOnInit() {
    this.route.url.subscribe(url => {
      if (url[0].path === 'labelprint') {
        this.isLabelPrintPageActive = true;
      }
    });
  }
}
